require('../../modules/es.object.get-own-property-descriptors');
var path = require('../../internals/path');

module.exports = path.Object.getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/get-own-property-descriptors.js
// module id = 582
// module chunks = 0 1